function isDevelopmentMode() {
    return 'development' === process.env.NODE_ENV;
}
function shouldDebugOptionUpdates() {
    return isDevelopmentMode() && 'true' === process.env.DEBUG_ECHARTS_OPTION_UPDATES;
}
export { isDevelopmentMode, shouldDebugOptionUpdates };

//# sourceMappingURL=env.js.map